"use client"

import { useEffect } from 'react'
import useAuthStore from '@/store/authStore'
import { setClientToken } from '@/lib/clientCookie'

/**
 * Ensures the auth token cookie exists for server-side middleware checks
 * by mirroring the persisted Zustand token into a client cookie on mount.
 */
export default function AuthCookieBridge() {
  const token = useAuthStore((s) => s.token)

  useEffect(() => {
    if (token) {
      try {
        setClientToken(token)
      } catch {}
    }
  }, [token])

  return null
}
